<template>
    <v-popover offset="0" :open="isOpen" trigger="manual" :autoHide="false">
        <button class="tooltip-target btn btn-sm btn-link" @click="open" :data-testid="(testPrefix || 'reception') + '-visit-state-' + visitId">
            <i class="fa fa-2x fa-circle-o text-info" aria-hidden="true" v-if="actualState === 'scheduled'"></i>
            <i class="fa fa-2x fa-clock-o text-success" aria-hidden="true" v-else-if="actualState === 'arrived'"></i>
            <i class="fa fa-2x fa-check-circle text-success" aria-hidden="true" v-else-if="actualState === 'completed'"></i>
            <i class="fa fa-2x fa-dot-circle-o text-warning" aria-hidden="true" v-else-if="actualState === 'elaborated'"></i>
            <i class="fa fa-2x fa-times-circle-o text-danger" aria-hidden="true" v-else-if="actualState === 'failed'"></i>
            <i class="fa fa-2x fa-dot-circle-o text-danger" aria-hidden="true" v-else-if="actualState === 'excused'"></i>
            <i class="fa fa-2x fa-times-circle text-danger" aria-hidden="true" v-else-if="actualState === 'canceled'"></i>
        </button>
        <template slot="popover">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h4>{{ states[actualState] }}</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <template v-if="actualState !== 'completed' && actualState !== 'elaborated' && actualState !== 'canceled'">
                    <button class="btn btn-primary m-1"  v-if="actualState !== 'scheduled'" @click="changeState('scheduled')" :data-testid="(testPrefix || 'reception') + '-visit-state-scheduled-' + visitId"><i class="fa fa-lg fa-circle-o" aria-hidden="true"></i> {{ states.scheduled }}</button>
                    <button class="btn btn-success m-1"  v-if="actualState !== 'arrived'" @click="changeState('arrived')" :data-testid="(testPrefix || 'reception') + '-visit-state-arrived-' + visitId"><i class="fa fa-lg fa-clock-o" aria-hidden="true"></i> {{ states.arrived }}</button>
                    <button class="btn btn-danger m-1"  v-if="actualState !== 'failed'" @click="changeState('failed')"><i class="fa fa-lg fa-times-circle-o" aria-hidden="true"></i> {{ states.failed }}</button>
                    <button class="btn btn-danger m-1"  v-if="actualState !== 'excused'" @click="changeState('excused')"><i class="fa fa-lg fa-dot-circle-o" aria-hidden="true"></i> {{ states.excused }}</button>
                </template>
                <template v-if="actualState === 'completed' || actualState === 'elaborated'">
                    <button class="btn btn-warning m-1"  v-if="actualState !== 'elaborated'" @click="changeState('elaborated')"><i class="fa fa-lg fa-dot-circle-o" aria-hidden="true"></i> {{ states.elaborated }}</button>
                    <button class="btn btn-success m-1"  v-if="actualState !== 'completed'" @click="changeState('completed')"><i class="fa fa-lg fa-check-circle" aria-hidden="true"></i> {{ states.completed }}</button>
                </template>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <button class="btn btn-sm btn-outline-danger mt-3" @click="close">zavřít</button>
            </div>
        </div>
    </div>
    </template>
    </v-popover>
</template>

<script>
  export default {
    data () {
      return {
        setting: require('../../../variables.js'),
        changePending: false,
        changeError: null,
        visit: {},
        isOpen: false,
        states: {
          scheduled: 'naplánováno',
          arrived: 'v čekárně',
          elaborated: 'rozpracovaný',
          failed: 'nepřišel (bez omluvy)',
          excused: 'nepřišel (omluvil se)',
          completed: 'dokončený',
          canceled: 'zrušený'
        }
      }
    },
    props: ['actualState', 'selectedDoctorId', 'visitId', 'testPrefix'],
    methods: {
      changeState (newState) {
        this.changePending = true
        this.visit.state = newState
        this.$http.put('visit/' + this.visitId, this.visit, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.changePending = false
          this.$emit('update')
          this.close()
          // this.$router.push({name: 'AddAddress', params: { clientid: response.data.id }})
          // this.$route.push()
        }).catch(error => {
          this.changeError = error.response.data.errors
          this.changePending = false
        })
      },
      open () {
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      }
    },
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }

    /*modal insurance*/

    tr.valid_line {
        font-weight: bold;
    }

    .modal_default {
        overflow: visible !important;
    }

    table.table td {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/HomeReceptionist/components/VisitChangeState.vue?25f049c2